import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Headers } from '@angular/http';

import {
    IProfile
} from './user.model'

@Injectable()
export class UserProfile {
    userProfile: IProfile = {
        token: '',
        expiration: '',
        claims: [{ type: '', value: '' }],
        currentUser: { id: '', userName: '', email: '' }
    };

    constructor(private router: Router) {

    }

    setProfile(profile: IProfile): void {
        if (typeof window !== 'undefined') {
            var nameid = profile.claims.filter(p => p.type == 'nameid')[0].value;
            var userName = profile.claims.filter(p => p.type == 'sub')[0].value;
            var email = profile.claims.filter(p => p.type == 'email')[0].value;
            window.localStorage.setItem('access_token', profile.token);
            window.localStorage.setItem('expires_in', profile.expiration);
            window.localStorage.setItem('nameid', nameid);
            window.localStorage.setItem('userName', userName);
            window.localStorage.setItem('email', email);
        }
    }

    getProfile(authorizationOnly: boolean = false): IProfile {
        
        if (typeof window !== 'undefined') {
            var accessToken = window.localStorage.getItem('access_token');
            //console.error(accessToken);
            if (accessToken != null && accessToken != '') {
                this.userProfile.token = accessToken;
                var expires_in = window.localStorage.getItem('expires_in');
                this.userProfile.expiration = expires_in !== null ? expires_in : '';
                if (this.userProfile.currentUser == null) {
                    this.userProfile.currentUser = { id: '', userName: '', email: '' }
                }

                var nameid = window.localStorage.getItem('nameid');
                this.userProfile.currentUser.id = nameid !== null ? JSON.parse(nameid) : { id: '', userName: '', email: '' };

                var userName = window.localStorage.getItem('userName');
                this.userProfile.currentUser.userName = userName !== null ? userName : '';
            }
            else {
                this.userProfile.token = null;
            }
        }
        else {
            this.userProfile.token = null;
        }
        return this.userProfile;
    }

    resetProfile() {
        if (typeof window !== 'undefined') {
            window.localStorage.removeItem('access_token');
            window.localStorage.removeItem('expires_in');
            this.userProfile = {
                token: '',
                expiration: '',
                claims: [{ type: '', value: '' }],
                currentUser: { id: '', userName: '', email: '' }
            };
        }
        return this.userProfile;
    }
}


// WEBPACK FOOTER //
// ./src/app/user/user.profile.ts